import { attr } from '@ember-data/model';

import type { Changes } from 'webapp/models-custom/block-state';
import BlockRecord from 'webapp/models/block';

export default class BlockPreviewRecord extends BlockRecord {
	@attr('string') previewHash!: string;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	changes!: Changes;
}
